import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const isEnglish = i18n.language === 'en';
  const buttonText = isEnglish ? t('languageSwitcher.toEt') : t('languageSwitcher.toEn');
  const ariaLabel = t('languageSwitcher.ariaLabel');

  const handleToggle = () => {
    const newLang = isEnglish ? 'et' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('voicequote-language', newLang);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleToggle}
      aria-label={ariaLabel}
      className="touch-target"
    >
      {buttonText}
    </Button>
  );
}
